import './core/state.js';
import './dom.js';
import './lib/math.js';
import './lib/random.js';
import './core/renderer.js';
import './core/scene.js';
import './core/post.js';
import './lib/factory.js';
import './lib/shapes.js';
import './lib/instancing.js';
import './textures/signs.js';
import './textures/windows.js';
import './textures/cloth.js';
import './textures/ground.js';
import './materials/stone.js';
import './materials/walls.js';
import './materials/surfaces.js';
import './materials/night.js';
import './data/stops.js';
import './data/stops-en.js';
import './data/logos.js';
import './data/i18n.js';
import { buildIsland } from './world/island.js';
import { buildSea } from './world/sea.js';
import { buildShore } from './world/shore.js';
import { buildEixample } from './world/eixample.js';
import { buildSagrada } from './world/sagrada.js';
import { buildLandmarks } from './world/landmarks.js';
import { buildTrees } from './world/trees.js';
import { buildFacadeDetails } from './world/facade-details.js';
import { buildSigns } from './world/signs.js';
import { buildStreetFurniture } from './world/street-furniture.js';
import { buildPark } from './world/park.js';
import { buildPeople } from './people/models.js';
import { buildCrowd } from './people/crowd.js';
import { buildWalking } from './people/walking.js';
import { buildBeachLife } from './world/beach-life.js';
import { buildPromenade } from './world/promenade.js';
import { buildBirds } from './fauna/birds.js';
import { buildRoadDetail } from './world/road-detail.js';
import { buildSidewalkDetail } from './world/sidewalk-detail.js';
import { buildScooter } from './vehicles/scooter.js';
import { buildRide } from './game/ride.js';
import { buildInput } from './game/input.js';
import { buildPhysics } from './game/physics.js';
import { buildRiding } from './game/riding.js';
import { buildCars } from './vehicles/cars.js';
import { buildTraffic } from './vehicles/traffic.js';
import { loadCarModels } from './vehicles/car-models.js';
import { buildClouds } from './world/clouds.js';
import { buildSeaLife } from './world/sea-life.js';
import { buildDayNight } from './game/daynight.js';
import { buildIntro } from './game/intro.js';
import { buildLang } from './ui/lang.js';
import { buildStopMarkers } from './game/stop-markers.js';
import { buildStopPanel } from './game/stop-panel.js';
import { buildFinale } from './game/finale.js';
import { buildStops } from './game/stops.js';
import { buildMinimap } from './ui/minimap.js';
import { buildTrafficToggle } from './ui/traffic-toggle.js';
import { buildFullscreen } from './ui/fullscreen.js';
import { optimiseScene } from './core/optimise.js';
import { buildCharacters } from './people/characters/index.js';
import { buildSettle } from './game/settle.js';
import { buildSplash } from './ui/splash.js';
import { buildQuality } from './core/quality.js';
import { startLoop } from './core/loop.js';

buildIsland();
buildSea();
buildShore();
buildEixample();
buildSagrada();
buildLandmarks();
buildTrees();
buildFacadeDetails();
buildSigns();
buildStreetFurniture();
buildPark();
buildPeople();
buildCrowd();
buildWalking();
buildBeachLife();
buildPromenade();
buildBirds();
buildRoadDetail();
buildSidewalkDetail();
buildScooter();
buildRide();
buildInput();
buildPhysics();
buildRiding();
buildCars();
buildTraffic();
buildClouds();
buildSeaLife();
buildDayNight();
buildIntro();
buildLang();
buildStopMarkers();
buildStopPanel();
buildFinale();
buildStops();
buildMinimap();
buildTrafficToggle();
buildFullscreen();
optimiseScene();
buildCharacters();
// the procedural cars stay if a vehicle file fails
loadCarModels().catch((e) => console.warn('vehicle models not loaded', e));
buildSettle();
buildSplash();
buildQuality();
startLoop();
